import {createContext, useContext} from 'react';

// FNP-412: when the current flow started, so the Verify Events panel can
// default its window to "since flow start". FlowClockProvider supplies it.

export type FlowClock = {
    startedAt: Date;
    restart: () => void;
};

export const FlowClockContext = createContext<FlowClock | null>(null);

export const useFlowClock = () => useContext(FlowClockContext);
